/*
 * NYORD: Header im NYORD-Stil (sections/header mit „nb_kopf“): Mega-Menü am Desktop (snippets/nb-mega).
 * Überfahren eines Kollektions-Punkts öffnet nach kurzer Pause dessen Panel, Verlassen schließt es mit Verzögerung,
 * damit man bequem ins Panel fahren kann. Per Tastatur: Fokus auf den Punkt öffnet, Esc schließt.
 */
(function () {
  var kopf = document.querySelector('.nb-kopfzeile');
  if (!kopf) return;
  // Höhe des klebenden Headers als --nb-kopf-hoehe (für klebende Seitenleisten und Sprungziele, z. B. im Blog);
  // ändert sich mit der Breite (einzeilig ab 1280px, zweizeilig darunter)
  var sektion = kopf.closest('.section-header') || kopf;
  var hoeheSetzen = function () {
    document.documentElement.style.setProperty('--nb-kopf-hoehe', Math.round(sektion.getBoundingClientRect().height) + 'px');
  };
  hoeheSetzen();
  if (window.ResizeObserver) new ResizeObserver(hoeheSetzen).observe(sektion);
  var bereich = kopf.querySelector('[data-nb-mega-bereich]');
  if (!bereich) return;
  var breit = window.matchMedia('(min-width: 990px)');
  var offen = null;
  var oeffnenTimer = null;
  var schliessenTimer = null;

  function panel(name) {
    return bereich.querySelector('[data-nb-mega-panel="' + name + '"]');
  }

  function setzen(name) {
    if (offen === name) return;
    if (offen) {
      var alt = panel(offen);
      if (alt) {
        alt.classList.remove('nb-mega__panel--offen');
        alt.setAttribute('aria-hidden', 'true');
        alt.querySelectorAll('a').forEach(function (a) {
          a.tabIndex = -1;
        });
      }
      var altLink = kopf.querySelector('[data-nb-mega="' + offen + '"]');
      if (altLink) altLink.setAttribute('aria-expanded', 'false');
    }
    offen = name;
    kopf.classList.toggle('nb-kopfzeile--mega', !!name);
    if (!name) return;
    var neu = panel(name);
    if (!neu) return;
    neu.classList.add('nb-mega__panel--offen');
    neu.setAttribute('aria-hidden', 'false');
    neu.querySelectorAll('a').forEach(function (a) {
      a.tabIndex = 0;
    });
    var link = kopf.querySelector('[data-nb-mega="' + name + '"]');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  function spaeterOeffnen(name) {
    clearTimeout(schliessenTimer);
    clearTimeout(oeffnenTimer);
    oeffnenTimer = setTimeout(function () {
      setzen(name);
    }, offen ? 60 : 140);
  }

  function spaeterSchliessen() {
    clearTimeout(oeffnenTimer);
    clearTimeout(schliessenTimer);
    schliessenTimer = setTimeout(function () {
      setzen(null);
    }, 220);
  }

  kopf.querySelectorAll('[data-nb-mega]').forEach(function (link) {
    link.setAttribute('aria-expanded', 'false');
    link.setAttribute('aria-controls', 'nb-mega-' + link.dataset.nbMega);
    link.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'mouse' && breit.matches) spaeterOeffnen(link.dataset.nbMega);
    });
    link.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') spaeterSchliessen();
    });
    link.addEventListener('focus', function () {
      if (breit.matches) setzen(link.dataset.nbMega);
    });
  });
  // Andere Menüpunkte (ohne Panel) schließen das offene Panel
  kopf.querySelectorAll('.header__inline-menu a:not([data-nb-mega])').forEach(function (a) {
    a.addEventListener('pointerenter', spaeterSchliessen);
    a.addEventListener('focus', function () {
      setzen(null);
    });
  });
  bereich.addEventListener('pointerenter', function () {
    clearTimeout(schliessenTimer);
  });
  bereich.addEventListener('pointerleave', spaeterSchliessen);
  bereich.addEventListener('focusout', function (e) {
    if (!kopf.contains(e.relatedTarget)) setzen(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && offen) {
      var link = kopf.querySelector('[data-nb-mega="' + offen + '"]');
      setzen(null);
      if (link) link.focus({ preventScroll: true });
    }
  });
  window.addEventListener(
    'scroll',
    function () {
      if (offen && !bereich.matches(':hover')) setzen(null);
    },
    { passive: true }
  );
})();
